import {h, Component} from 'preact';
import {connect} from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';
import designDomain from '../domain/designDomain';
import imageService from '../service/imageService';
import Spinner from "./Spinner";
import designService from "../service/designService";
import $ from "jquery";
import constants from "../constants";
import linkRef from "linkref";
import {createPortal} from "preact/compat";
import illustrationService from '../service/illustrationService';

export default @connect(reduce, actions)
class ConfigureFreeImageModal extends Component {

  constructor() {
    super();

    this.state = {
      isLoadingDetails: false,
      picker: '',
      config: '',

      id: '',
      privacy: '',
      content: '',
      tags: [],
      categories: constants.freeCategories,
      imageCategories: [],
      popular: 'false',
      s3Path: '',

      tagSuggestions: [],
      newTagName: '',
      newFolderName: '',
      widgetColor: '#000000',
    };

    this.remove = () => {
      if (!this.props.isDesigner) return;
      window.ConfirmationModal.show({
        title: 'Are you sure?',
        body: 'This photo will be removed from the gallery.',
        acceptLabel: 'OK',
        declineLabel: 'Cancel',
        onAccept: () => {
          /*designService.removeIllustration(this.state.id).then(response => {
            this.props.onModalClose()
          })*/
        },
        onDecline: () => {
          window.ConfirmationModal.hide()
        }
      })
    };

    this.save = () => {
      let catIdsString = this.state.categories.filter(cat => this.state.imageCategories.includes(cat.label)).map(cat => cat.id).join(',');
      let tagsString = JSON.stringify(this.state.tags);
      imageService.updateImage({
        id: this.state.id,
        privacy: this.state.privacy,
        imageTags: tagsString,
        popular: this.state.popular,
        categoryIdList: catIdsString,
      }).then(response => {
        this.props.onModalClose();
      }).catch((err) => {
        window.InfoModal.show({
          title: 'Whoops!',
          body: 'We failed to save your work. Please try again later!',
          acceptLabel: 'Got it',
        })
      })
    };

    this.onChangePrivacy = (ev) => {
      this.setState({privacy: ev.target.value});
    };

    this.onChangePopular = (ev) => {
      this.setState({popular: ev.target.value});
    };

    this.removeTag = (tag) => {
      this.setState({tags: this.state.tags.filter(t => t.id !== tag.id)});
    };

    this.addTag = (tag) => {
      const found = this.state.tags.find(t => t.id === tag.id);
      if (found) return;

      this.setState({
        tags: [tag, ...this.state.tags],
        tagSuggestions: [],
        newTagName: ''
      });
    };

    this.createTag = (tag) => {
      const name = tag || this.state.newTagName;
      const dto = [];
      if (name.indexOf(',') > -1) {
        name.split(',').forEach(it => {
          dto.push({name: it.trim()})
        })
      } else {
        dto.push({name});
      }
      illustrationService.createTag(dto).then(resp => {
        resp.data.forEach(it => {
          setTimeout(() => {
            this.addTag(new designDomain.DesignIllustrationTag(it));
          }, 50);
        });
      })
    }

    this.updateNewTagName = (ev) => {
      this.setState({newTagName: ev.target.value});
    };

    this.onNewTagKeyUp = (ev) => {
      if (ev.keyCode === 13 || ev.keyCode === 188) {
        const value = ev.keyCode === 188 ? ev.target.value.slice(0, -1) : ev.target.value
        this.createTag(value);
        this.resetNewTag();
      }
    };

    this.removeCat = (cat) => {
      this.setState({imageCategories: this.state.imageCategories.filter(c => c !== cat)});
    };

    this.addCategory = (cat) => {
      let alreadyHas = this.state.imageCategories.forEach((c) => c.toLowerCase() === cat.toLowerCase());
      if (alreadyHas) return;

      const found = constants.freeCategories.find(c => c.label.toLowerCase() === cat.toLowerCase()).label;
      if (found) this.setState({ imageCategories: [found, ...this.state.imageCategories]})
    };

    this.onNewCatKeyUp = (ev) => {
      if (ev.keyCode === 13 || ev.keyCode === 188) {
        const value = ev.keyCode === 188 ? ev.target.value.slice(0, -1) : ev.target.value;
        this.addCategory(value);
        this.resetNewCategory();
      }
    };

    this.resetNewTag = () => {
      this.setState({
        newTagName: '',
        tagSuggestions: []
      });
    };

    this.resetNewCategory = () => {
      $('#catNameInput').val('');
    };

    this.download = () => {
      window.open(constants.SECURE_S3_PATH + this.props.freeImageToConfigure.s3Path, '_blank').focus();
    };
  }

  init(image) {
    let imageCategories = this.state.categories.filter(it => it.id === image.categoryId).map(it => it.label);
    if (image.categoryIdList.length > 0) {
      imageCategories = this.state.categories.filter(cat => image.categoryIdList.includes(cat.id)).map(cat => cat.label);
    }
    this.setState({
      id: image.id,
      privacy: image.privacy,
      tags: image.imageTags,
      imageCategories: imageCategories,
      popular: image.popular,
      s3Path: image.s3Path
    })
  }

  render({open, freeImageToConfigure, onModalClose, into = 'body', children, isAdmin},
         {
           id, tags, privacy, popular, newTagName, tagSuggestions, imageCategories, categories, selectedCategory, newFolderName, isLoadingDetails
         }) {

    if (freeImageToConfigure && freeImageToConfigure.id !== id) {
      this.init(this.props.freeImageToConfigure)
    }

    tags.sort((a, b) => a.name.localeCompare(b.name))

    const tagElements = tags.map(tag => {
      return (
        <div className="tag">
          {tag.name}
          <a className="remove" onClick={() => this.removeTag(tag)}>x</a>
        </div>
      )
    });

    const suggestionElements = tagSuggestions.map(suggestion => {
      return (
        <li className="suggestion">
          <a onClick={() => this.addTag(suggestion)}>{suggestion.name}</a>
        </li>
      )
    });

    let suggestions = null;
    if (tagSuggestions.length > 0) {
      suggestions = <div className="suggestions">{suggestionElements}</div>
    } else if (newTagName.length > 0) {
      suggestions = <div className="new-tag"><a onClick={() => this.createTag()}>+ Create Tag</a></div>
    }

    let categoryElements = imageCategories.map(cat => {
      return (
        <div className="tag">
          {cat}
          <a className="remove" onClick={() => this.removeCat(cat)}>x</a>
        </div>
      )
    })

    let image = <img style="width: 100%;" src={constants.SECURE_S3_PATH + this.props.freeImageToConfigure.s3Path}></img>

    const loadingSpinner = isLoadingDetails ? <Spinner/> : null;

    return open ? createPortal(<div>
      <div className="modal-back" onClick={onModalClose}></div>
      <div className="modal config-modal" style="transition: left 0.4s cubic-bezier(0.87, 0.04, 0.21, 1.12) 0s;">
        {loadingSpinner}

        <div className="content" style="display: flex; align-items: center;">
          <div style="width:40%; padding: 20px 20px 0px 0px;">
            {image}
          </div>
          <div className="svg-fields" style="width:60%;">
            <header>
              <h2 style="padding-left: 0;">Free Image Settings</h2>
            </header>

            <div className="form-block">
              <label>Privacy</label>
              <select value={privacy} onChange={this.onChangePrivacy}>
                <option value="private">Private</option>
                <option value="public">Public</option>
              </select>
            </div>

            <div className="form-block">
              <label>Tags</label>
              <div className="tags">{tagElements}</div>
              <input type="text"
                     placeholder="Tag name..."
                     value={newTagName}
                     onChange={this.updateNewTagName}
                     onKeyUp={this.onNewTagKeyUp}/>
              {suggestions}
            </div>

            <div className="form-block">
              <label>Folders</label>
              <div className="tags">{categoryElements}</div>
              <input id="catNameInput"
                     type="text"
                     placeholder="Folder name..."
                     onKeyUp={this.onNewCatKeyUp}/>
            </div>

            <div className="form-block">
              <label>Popular</label>
              <select value={popular} onChange={this.onChangePopular}>
                <option value="true">yes</option>
                <option value="false">no</option>
              </select>
            </div>

            <footer>
              {/*<a className="btn decline" onClick={() => this.remove()}>Remove</a>*/}
              <a className="btn primary pull-right accept" onClick={() => this.save()}>Save</a>
              <a className="btn primary pull-right accept" onClick={() => this.download()}>Download</a>
            </footer>
          </div>
        </div>
      </div>
    </div>, document.getElementById('modals')) : null;
  }
}
